module.exports = __webpack_public_path__ + "img/google-logo.e99543bb.svg";